import script from "./ServiceCards.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceCards.vue?vue&type=script&setup=true&lang=js"

import "./ServiceCards.vue?vue&type=style&index=0&id=ab04f880&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab04f880"]])

export default __exports__